import { FC, useRef, useEffect, useState } from 'react'
import { ThemeProvider } from 'components/features/theme/ThemeProvider/ThemeProvider'

type InputStateThemeProps = {
  hasError?: boolean
}
export const InputStateTheme: FC<InputStateThemeProps> = (props) => {
  const { children, hasError } = props

  const [isFocused, setIsFocused] = useState(false)
  const isFocusedRef = useRef(isFocused)
  isFocusedRef.current = isFocused
  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const { current } = rootRef
    if (!current) {
      return
    }

    const handler = () => {
      const isContains = current.contains(document.activeElement)
      if (isContains !== isFocusedRef.current) {
        setIsFocused(isContains)
      }
    }

    current.addEventListener('focusin', handler, false)
    current.addEventListener('focusout', handler, false)

    return () => {
      current.removeEventListener('focusin', handler, false)
      current.removeEventListener('focusout', handler, false)
    }
  }, [])

  return (
    <div ref={ rootRef }>
      <ThemeProvider inputActive={ isFocused } inputError={ !!hasError }>
        { children }
      </ThemeProvider>
    </div>
  )
}
